import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=201ea341&scoped=true&"
var script = {}
import style0 from "./Faq.vue?vue&type=style&index=0&id=201ea341&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201ea341",
  null
  
)

export default component.exports